import { useState, type JSX } from 'react';
import { cn } from '@/lib/utils';

export function CompanyLogoMark({
  logoUrl,
  size = 'md',
  className,
}: {
  logoUrl?: string | null;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}): JSX.Element | null {
  const [hasError, setHasError] = useState(false);
  const normalizedUrl = logoUrl?.trim();

  if (!normalizedUrl || hasError) return null;

  const sizeClass = size === 'sm' ? 'h-9 w-[4.5rem]' : size === 'lg' ? 'h-12 w-24' : 'h-10 w-20';

  return (
    <div
      className={cn(
        'group flex items-center justify-center rounded-md bg-transparent p-0',
        sizeClass,
        className
      )}
    >
      <img
        src={normalizedUrl}
        alt="Logo aziendale"
        className="company-logo-muted max-h-full max-w-full object-contain"
        onError={() => setHasError(true)}
      />
    </div>
  );
}
